module.exports = __webpack_public_path__ + "img/home.536bf505.svg";